var components
try {
  components = {
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
    uniList: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-list/components/uni-list/uni-list" */ "@/uni_modules/uni-list/components/uni-list/uni-list.vue"
      )
    },
    uniListItem: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-list/components/uni-list-item/uni-list-item" */ "@/uni_modules/uni-list/components/uni-list-item/uni-list-item.vue"
      )
    },
    uReadMore: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-read-more/u-read-more" */ "uview-ui/components/u-read-more/u-read-more.vue"
      )
    },
    uParse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-parse/u-parse" */ "uview-ui/components/u-parse/u-parse.vue"
      )
    },
    mpHtml: function () {
      return import(
        /* webpackChunkName: "uni_modules/mp-html/components/mp-html/mp-html" */ "@/uni_modules/mp-html/components/mp-html/mp-html.vue"
      )
    },
    uAlertTips: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-alert-tips/u-alert-tips" */ "uview-ui/components/u-alert-tips/u-alert-tips.vue"
      )
    },
    vkDataInputEditor: function () {
      return import(
        /* webpackChunkName: "components/vk-data-input-editor/vk-data-input-editor" */ "@/components/vk-data-input-editor/vk-data-input-editor.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var f0 = _vm._f("timeFrom")(_vm.question._add_time)
  var g0 = _vm.comments.length
  var l0 = _vm.__map(_vm.comments, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var f1 = _vm._f("timeFrom")(item._add_time)
    return {
      $orig: $orig,
      f1: f1,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        f0: f0,
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }